import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { LocalMall, AccountBalance } from '@mui/icons-material';
import { useNavigation } from '../context/NavigationContext';

const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isNavigationVisible } = useNavigation();

  if (!isNavigationVisible) {
    return null;
  }

  return (
    <BottomNavigation
      value={location.pathname}
      onChange={(_, newValue) => {
        navigate(newValue);
      }}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#1a1a1a',
        height: '72px',
        '& .MuiBottomNavigationAction-root': {
          paddingTop: '8px',
          '& .MuiBottomNavigationAction-label': {
            marginTop: '4px',
          },
        },
      }}
    >
      <BottomNavigationAction
        label="Mint"
        value="/mint"
        icon={<LocalMall />}
      />
      <BottomNavigationAction
        label="Staking"
        value="/staking"
        icon={<AccountBalance />}
      />
    </BottomNavigation>
  );
};

export default Navigation; 